/**
 * 独立集合卡片：色系切换 / 第二张悬停图。事件委托；仅在 #ProductGridContainer 子树被整体替换时重新 hydrate，避免改价导致闪动。
 */
(function () {
  function optionKey(optionIndex) {
    var n = parseInt(optionIndex, 10);
    if (isNaN(n) || n < 0 || n > 2) n = 0;
    return ['option1', 'option2', 'option3'][n];
  }

  function normalizeLabel(x) {
    if (x == null || x === '') return '';
    if (typeof x === 'string') return x.trim();
    if (typeof x === 'object') {
      if (typeof x.name === 'string') return x.name.trim();
      if (typeof x.title === 'string') return x.title.trim();
    }
    return String(x).trim();
  }

  function normalizeOptionIndex(cfg) {
    var n = parseInt(cfg.optionIndex, 10);
    return isNaN(n) ? 0 : n;
  }

  function findVariant(variants, optionIndex, rawValue) {
    var value = normalizeLabel(rawValue);
    if (!value || !variants || !variants.length) return null;
    var key = optionKey(optionIndex);
    return (
      variants.find(function (v) {
        return normalizeLabel(v[key]) === value && v.available;
      }) ||
      variants.find(function (v) {
        return normalizeLabel(v[key]) === value;
      })
    );
  }

  function mediaId(m) {
    if (!m || m.id == null) return null;
    return m.id;
  }

  /** 与 Vernal-Card-Process 一致的 variant 组图切片；id 用宽松比较 */
  function getVariantImageSources(variants, media, variant, mainIdx, hoverIdx) {
    if (!variant || !media || !media.length) {
      return [null, null];
    }

    var fm = variant.featured_media || variant.featured_image;
    if (!fm || fm.id == null) {
      return [null, null];
    }
    var currentMasterImgId = fm.id;

    var variantMasterImgIdArr = [];
    variants.forEach(function (item) {
      var f = item.featured_media || item.featured_image;
      if (f && f.id != null && variantMasterImgIdArr.indexOf(f.id) === -1) {
        variantMasterImgIdArr.push(f.id);
      }
    });

    var currentVariantImgArr = [];
    var start = false;
    for (var i = 0; i < media.length; i++) {
      var img = media[i];
      var id = mediaId(img);
      if (!start && id != null && id == currentMasterImgId) {
        start = true;
        currentVariantImgArr.push(img);
      } else if (start) {
        if (id != null && variantMasterImgIdArr.some(function (vid) { return vid == id; })) break;
        currentVariantImgArr.push(img);
      }
    }

    if (!currentVariantImgArr.length && fm && fm.src) {
      currentVariantImgArr.push(fm);
    }

    function srcAt(i) {
      var entry = currentVariantImgArr[i];
      if (!entry || !entry.src) return null;
      var s = entry.src;
      return s.indexOf('//') === 0 ? 'https:' + s : s;
    }

    var mi = typeof mainIdx === 'number' ? mainIdx : 0;
    var hi = typeof hoverIdx === 'number' ? hoverIdx : mi;

    return [srcAt(mi), srcAt(hi)];
  }

  function parseJson(el) {
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function updatePrice(card, variant, moneyFormat) {
    var box = card.querySelector('.vernal-aggregate-card__price');
    if (!box || !variant) return;

    var priceEl = box.querySelector('[data-role="price-money"]');
    if (!priceEl) return;

    var cents = variant.price;
    if (typeof cents !== 'number') return;

    var next = formatMoney(cents, moneyFormat);
    if (priceEl.textContent !== next) {
      priceEl.textContent = next;
    }
  }

  function formatMoney(cents, formatString) {
    var fs = formatString || '{{amount}}';
    var dec = (cents / 100).toFixed(2);
    var rnd = String(Math.round(cents / 100));
    fs = fs.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, rnd);
    fs = fs.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dec.replace('.', ','));
    fs = fs.replace(/\{\{\s*amount\s*\}\}/g, dec);
    return fs;
  }

  function updateUrls(card, variant, productUrl) {
    var vId = variant && variant.id;
    if (!vId || !productUrl) return;

    var qsBase = productUrl.split('?')[0];
    var link = qsBase + '?variant=' + vId;

    var mediaL = card.querySelector('.vernal-aggregate-card__media-link-js');
    if (mediaL) mediaL.href = link;

    var titleL = card.querySelector('.vernal-aggregate-card__title-link-js');
    if (titleL) titleL.href = link;

    card.setAttribute('data-active-variant-id', String(vId));
  }

  function applyVariantVisual(card, v, variants, media, cfg, opts) {
    opts = opts || {};
    if (!card || !v || !variants || !media || !cfg) return;

    var showHover = !!cfg.showHover;
    var hoverIdx = showHover ? 1 : 0;

    var pair = getVariantImageSources(variants, media, v, 0, hoverIdx);

    var mainEl = card.querySelector('.vernal-aggregate-card__img--primary');
    var hoverEl = card.querySelector('.vernal-aggregate-card__img--hover');
    var wrap = card.querySelector('.vernal-aggregate-card__media-inner');

    if (mainEl && pair[0]) {
      if (mainEl.getAttribute('src') !== pair[0]) {
        mainEl.src = pair[0];
      }
      mainEl.removeAttribute('srcset');
    }

    var canDual = !!(showHover && hoverEl && pair[0] && pair[1] && pair[1] !== pair[0]);

    if (canDual) {
      hoverEl.src = pair[1];
      hoverEl.removeAttribute('hidden');
      hoverEl.classList.add('vernal-aggregate-card__img--hover--ready');
      if (wrap) wrap.classList.add('vernal-aggregate-card__media-inner--dual');
    } else if (hoverEl) {
      hoverEl.removeAttribute('src');
      hoverEl.setAttribute('hidden', '');
      hoverEl.classList.remove('vernal-aggregate-card__img--hover--ready');
      if (wrap) wrap.classList.remove('vernal-aggregate-card__media-inner--dual');
    }

    if (!opts.skipPrice) {
      updatePrice(card, v, cfg.moneyFormat);
    }
    updateUrls(card, v, cfg.productUrl);
  }

  function parseColorLabels(cfg) {
    var raw = cfg.colorLabels;
    if (!Array.isArray(raw)) return [];
    return raw.map(normalizeLabel).filter(Boolean);
  }

  function hydrateCard(card) {
    if (card.getAttribute('data-vernal-hydrated') === '1') return;

    var variants = parseJson(card.querySelector('.vernal-aggregate-card__variants'));
    var media = parseJson(card.querySelector('.vernal-aggregate-card__media'));
    var cfg = parseJson(card.querySelector('.vernal-aggregate-card__config'));
    if (!variants || !media || !cfg) return;

    var oi = normalizeOptionIndex(cfg);
    var labels = parseColorLabels(cfg);
    var activeRaw = cfg.activeColorLabel != null ? cfg.activeColorLabel : labels[0];
    var activeLabel = normalizeLabel(activeRaw);

    var v = activeLabel ? findVariant(variants, oi, activeLabel) : variants[0];
    if (!v) return;

    applyVariantVisual(card, v, variants, media, cfg, { skipPrice: true });
    card.setAttribute('data-vernal-hydrated', '1');
  }

  function hydrateContainer(root) {
    if (!root) return;
    root.querySelectorAll('.vernal-aggregate-card').forEach(function (card) {
      card.removeAttribute('data-vernal-hydrated');
      hydrateCard(card);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.vernal-aggregate-card__swatch');
    if (!btn) return;

    var card = btn.closest('.vernal-aggregate-card');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();

    var label = normalizeLabel(btn.getAttribute('data-color-label'));
    var variants = parseJson(card.querySelector('.vernal-aggregate-card__variants'));
    var media = parseJson(card.querySelector('.vernal-aggregate-card__media'));
    var cfg = parseJson(card.querySelector('.vernal-aggregate-card__config'));

    if (!variants || !media || !cfg || !label) return;

    var v = findVariant(variants, normalizeOptionIndex(cfg), label);
    if (!v) return;

    applyVariantVisual(card, v, variants, media, cfg);

    card.querySelectorAll('.vernal-aggregate-card__swatch').forEach(function (s) {
      s.classList.toggle('is-active', s === btn);
    });
    card.setAttribute('data-vernal-hydrated', '1');
  });

  function setupObserver() {
    var pg = document.getElementById('ProductGridContainer');
    if (!pg || pg.getAttribute('data-vernal-observe') === '1') return;

    pg.setAttribute('data-vernal-observe', '1');

    hydrateContainer(pg);

    var t;
    var obs = new MutationObserver(function (mutations) {
      var significant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList') continue;
        if (m.addedNodes && m.addedNodes.length) {
          significant = true;
          break;
        }
        if (m.removedNodes && m.removedNodes.length) {
          significant = true;
          break;
        }
      }
      if (!significant) return;

      clearTimeout(t);
      t = setTimeout(function () {
        hydrateContainer(pg);
      }, 16);
    });
    // 只监听的直接子节点变化（facets.js 会整体替换内部 collection 块），避免改价格等子树变更反复 hydrate
    obs.observe(pg, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }

  /**
   * 移动端筛选横条 overflow-x 会裁切下拉。面板在初始化时移入 .filter-panels（与横条同级、无 overflow），
   * 打开时用 fixed 对齐 pill；facets.js 局部刷新后会重新 dock。
   */
  var MOBILE_FILTER_ROW_SEL = '[data-vernal-filter-row]';
  var MOBILE_FILTER_PANELS_SEL = '[data-vernal-filter-panels]';
  var MOBILE_PANEL_SEL = '.vernal-coll-facet-toolbar__facet-panel--mobile';
  var DROP_UNBIND = '__vernalFacetMobileDropUnbind';

  function getMobileFilterContext() {
    var row = document.querySelector(MOBILE_FILTER_ROW_SEL);
    var panelsRoot = document.querySelector(MOBILE_FILTER_PANELS_SEL);
    if (!row || !panelsRoot) return null;
    return { row: row, panelsRoot: panelsRoot };
  }

  function getFilterIndexFromDetails(details) {
    var jsFilter = details && details.closest('.js-filter');
    return jsFilter ? jsFilter.getAttribute('data-index') : null;
  }

  function getPanelSlot(panelsRoot, index) {
    if (!panelsRoot || !index) return null;
    return panelsRoot.querySelector('.vernal-coll-facet-mobile__filter-panel-slot[data-for-index="' + index + '"]');
  }

  function getDockedPanel(panelsRoot, index) {
    var slot = getPanelSlot(panelsRoot, index);
    return slot ? slot.querySelector(MOBILE_PANEL_SEL) : null;
  }

  /** 将 .js-filter 内的面板移入横条外的 slot，避免落在 overflow-x 容器内 */
  function dockMobileFacetPanels(ctx) {
    if (!ctx) ctx = getMobileFilterContext();
    if (!ctx) return;

    ctx.row.querySelectorAll('.js-filter[data-index^="mobile-"]').forEach(function (jsFilter) {
      var index = jsFilter.getAttribute('data-index');
      var panel = jsFilter.querySelector(MOBILE_PANEL_SEL);
      var slot = getPanelSlot(ctx.panelsRoot, index);
      if (!panel || !slot) return;
      if (panel.parentNode !== slot) {
        slot.appendChild(panel);
      }
    });
  }

  function resetFloatedFacetPanel(details, panel, slot) {
    if (!panel) return;
    panel.classList.remove('vernal-coll-facet-mobile__facet-panel--floated');
    panel.style.removeProperty('position');
    panel.style.removeProperty('top');
    panel.style.removeProperty('left');
    panel.style.removeProperty('right');
    panel.style.removeProperty('bottom');
    panel.style.removeProperty('width');
    panel.style.removeProperty('max-height');
    panel.style.removeProperty('margin');
    panel.style.removeProperty('z-index');
    panel.style.removeProperty('visibility');
    panel.style.removeProperty('opacity');
    panel.style.removeProperty('display');
    if (slot) {
      slot.hidden = true;
    }
    if (details) {
      delete details.__vernalMobileFacetPanelEl;
    }
  }

  function positionFloatedFacetPanel(details, panel, slot) {
    var summary = details.querySelector('summary');
    if (!summary || !panel || !slot) return;

    var r = summary.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var margin = 12;
    var gap = 4;

    var isPrice = panel.classList.contains('facets__price');
    var floorMin = isPrice ? 280 : 200;
    var maxW = Math.min(360, vw - 2 * margin);
    var cw = Math.ceil(r.width);
    var desired = Math.max(cw > 0 ? cw : floorMin, floorMin);
    var w = Math.min(maxW, desired);
    var left = r.left;
    if (left + w > vw - margin) {
      left = Math.max(margin, vw - margin - w);
    } else if (left < margin) {
      left = margin;
    }

    var top = r.bottom + gap;
    var roomBelow = vh - top - margin;
    var panelMax = Math.floor(Math.min(vh * 0.6, Math.max(roomBelow, 120)));

    slot.hidden = false;
    var panelsRoot = slot.parentNode;
    if (panelsRoot) {
      panelsRoot.hidden = false;
    }

    panel.classList.add('vernal-coll-facet-mobile__facet-panel--floated');
    panel.style.display = 'block';
    panel.style.position = 'fixed';
    panel.style.top = Math.round(top) + 'px';
    panel.style.left = Math.round(left) + 'px';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
    panel.style.width = Math.round(w) + 'px';
    panel.style.maxHeight = panelMax + 'px';
    panel.style.margin = '0';
    panel.style.zIndex = '102';
    panel.style.visibility = 'visible';
    panel.style.opacity = '1';
  }

  function closeOtherMobileFilterDetails(exceptDetails, ctx) {
    if (!ctx) return;
    ctx.row.querySelectorAll('details.facets__disclosure[open]').forEach(function (det) {
      if (det === exceptDetails) return;
      det.removeAttribute('open');
    });
  }

  function bindFacetPanelReposition(details, panel, slot) {
    var reposition = function () {
      if (details.open) {
        positionFloatedFacetPanel(details, panel, slot);
      }
    };

    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);

    var row = details.closest(MOBILE_FILTER_ROW_SEL);
    if (row) {
      row.addEventListener('scroll', reposition, { passive: true });
    }

    var ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(reposition);
      ro.observe(details);
      ro.observe(panel);
    }

    return function unbind() {
      window.removeEventListener('scroll', reposition, true);
      window.removeEventListener('resize', reposition);
      if (row) {
        row.removeEventListener('scroll', reposition);
      }
      if (ro) {
        try {
          ro.disconnect();
        } catch (ignoreErr) {
          /* */
        }
      }
    };
  }

  function onMobileFacetToolbarToggle(evt) {
    var details = evt.currentTarget || evt.target;
    if (!details || details.tagName !== 'DETAILS') return;

    var ctx = getMobileFilterContext();
    if (!ctx || !details.closest(MOBILE_FILTER_ROW_SEL)) return;

    var index = getFilterIndexFromDetails(details);
    var slot = getPanelSlot(ctx.panelsRoot, index);
    var panel = getDockedPanel(ctx.panelsRoot, index);
    if (!slot || !panel) return;

    details.__vernalMobileFacetPanelEl = panel;

    var prev = details[DROP_UNBIND];
    if (typeof prev === 'function') {
      prev();
      delete details[DROP_UNBIND];
    }

    if (details.open) {
      closeOtherMobileFilterDetails(details, ctx);
      positionFloatedFacetPanel(details, panel, slot);
      window.requestAnimationFrame(function () {
        if (!details.open) return;
        positionFloatedFacetPanel(details, panel, slot);
        details[DROP_UNBIND] = bindFacetPanelReposition(details, panel, slot);
      });
    } else {
      resetFloatedFacetPanel(details, panel, slot);
    }
  }

  function wireMobileFacetFilterRowDetails(ctx) {
    if (!ctx) ctx = getMobileFilterContext();
    if (!ctx) return;

    dockMobileFacetPanels(ctx);

    ctx.row.querySelectorAll('details.facets__disclosure').forEach(function (det) {
      if (det.dataset.vernalFloaterDetailBound === '1') return;
      det.dataset.vernalFloaterDetailBound = '1';
      det.addEventListener('toggle', onMobileFacetToolbarToggle);
    });
  }

  function initMobileFacetFilterRowFloaterBindings() {
    var ctx = getMobileFilterContext();
    if (!ctx) return;

    wireMobileFacetFilterRowDetails(ctx);

    if (typeof MutationObserver === 'undefined' || ctx.row.dataset.vernalFloaterObserver === '1') return;
    ctx.row.dataset.vernalFloaterObserver = '1';

    var debounceWire;
    var obs = new MutationObserver(function () {
      clearTimeout(debounceWire);
      debounceWire = setTimeout(function () {
        wireMobileFacetFilterRowDetails(ctx);
      }, 0);
    });
    obs.observe(ctx.row, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-vernal-facet-close]');
    if (!closeBtn) return;
    var slot = closeBtn.closest('.vernal-coll-facet-mobile__filter-panel-slot');
    if (!slot) return;
    var index = slot.getAttribute('data-for-index');
    var ctx = getMobileFilterContext();
    if (!ctx || !index) return;
    var det = ctx.row.querySelector('.js-filter[data-index="' + index + '"] details');
    if (det) det.removeAttribute('open');
  });

  function bootMobileFacetFilterRowFloater() {
    initMobileFacetFilterRowFloaterBindings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMobileFacetFilterRowFloater);
  } else {
    bootMobileFacetFilterRowFloater();
  }

  document.addEventListener('shopify:section:load', bootMobileFacetFilterRowFloater);

  window.vernalDockMobileFacetPanels = function () {
    var ctx = getMobileFilterContext();
    if (ctx) wireMobileFacetFilterRowDetails(ctx);
  };
})();
